import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AlertController, Platform} from "ionic-angular";
import * as md5 from "md5";
import {Network} from "@ionic-native/network";
import {Device} from "@ionic-native/device";
import {DatabaseModel} from "../../models/database.model";
import {UserModel} from "../../models/user.model";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class GlobalProvider {

  public calendarName = 'CLEVERREPORT';
  // public remoteDatabaseURL = "http://helbighof.de:5984";
  // public apiURL = "http://smartaudit.helbighof.de:8080";
  public remoteDatabaseURL = "https://cleverreport.de:6984";
  public apiURL = "https://api.cleverreport.de";
  // public apiURL = "http://127.0.0.1:8080";
  public shopURL = "https://cleverreport.de/shop"
  public readonly: boolean = true;

  public OK_TEXT: string = "OK";
  public CANCEL_TEXT: string = "Abbrechen";
  public DONE_TEXT: string = "Übernehmen";


  public user: UserModel = null;
  public database: DatabaseModel = null;
  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(public http: HttpClient,
              private plt: Platform,
              private network: Network,
              private alertCtrl: AlertController,
              private device: Device) {
    console.log('Hello GlobalProvider Provider');
    // this.readConfigFromLocalstorage();
  }

  public isBrowser(): boolean {
    // return this.plt.is('mobile') || this.plt.is('mobileweb');
    // return this.plt.is('core') || this.plt.is('mobile') || this.plt.is('mobileweb');
    // return !this.plt.is('windows') && !this.plt.is('ios') && !this.plt.is('android');
    return (this.device.platform && this.device.platform.toLowerCase() === 'browser') || !this.device.platform
  }

  public isCordova(): boolean {
    return this.plt.is('cordova');
  }

  public validateLicenseApiResponse(data: any) : boolean {

    let signatureFromResponse = null;
    let dataToValidate = null;

    if(data.hasOwnProperty('sig')){
      signatureFromResponse = data['sig'];
      dataToValidate = JSON.parse(JSON.stringify(data));
      delete dataToValidate['sig'];
    }


    let sigjoined: Array<any> = [];
    for(let key in dataToValidate){
      sigjoined.push(key + '=' + dataToValidate[key]);
    }

    let sig = sigjoined.join('&');
    sig = md5(sig);

    return signatureFromResponse === sig;

  }

  public hasInternet(title: string = null, subtitle: string = null): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if(this.network.type === 'none'){
        let alertMessage = this.alertCtrl.create({
          title: title || 'Keine Internetverbindung',
          subTitle: subtitle || 'Bitte stellen Sie sicher, dass Sie mit dem Internet verbunden sind und versuchen Sie es noch einmal'
        });
        alertMessage.present();
        reject();
      }
      else{
        resolve(true);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts